/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-dropdown {
  font-family: Frutiger-Bold, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  display: block;
  font-size: 12px;
  position: relative;
  text-transform: uppercase;
}
.ux-dropdown__label {
  appearance: none;
  background-color: transparent;
  border: var(--ux-button-border-width) solid var(--ux-button-border-color);
  border-radius: 0;
  box-shadow: var(--ux-button-shadow);
  color: var(--ux-input-text-color);
  cursor: pointer;
  font-family: var(--ux-font);
  font-size: var(--ux-select-font-size);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: var(--ux-select-font-weight);
  height: var(--ux-input-height);
  opacity: 1;
  outline: var(--ux-input-outline-width) solid transparent;
  outline-offset: var(--ux-input-outline-offset);
  padding: var(--ux-select-padding);
  text-align: start;
  text-decoration: none;
  text-rendering: optimizeLegibility;
  text-transform: var(--ux-button-text-transform);
  width: 100%;
  align-items: center;
  display: flex;
  height: auto;
  justify-content: space-between;
  min-height: var(--ux-input-height);
  padding: var(--ux-dropdown-padding);
}
.ux-dropdown__label:focus-visible {
  outline: var(--ux-select-focus-border-width) solid var(--ux-button-focus-border-color);
  border-color: var(--ux-button-focus-border-color);
}
.ux-dropdown__label:focus-visible + .ux-dropdown__dropdown-locator .ux-dropdown__menu {
  outline: var(--ux-select-focus-border-width) solid var(--ux-button-focus-border-color);
  border-color: var(--ux-button-focus-border-color);
  outline-offset: var(--ux-input-outline-offset);
}
.ux-dropdown__label ux-icon {
  fill: currentColor;
  font-size: var(--ux-select-icon-size);
  transition: transform 250ms ease-out;
}
.ux-dropdown__label--light {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  font-size: 15px;
  padding-bottom: var(--ux-input-padding-vertical);
  padding-top: var(--ux-input-padding-vertical);
  text-transform: none;
}
.ux-dropdown__counter {
  display: inline-block;
  background-color: var(--ux-button-selected-bg-color);
  color: var(--ux-button-selected-text-color);
  border-radius: 50%;
  width: 21px;
  height: 21px;
  text-align: center;
  line-height: 1.6;
  margin-left: 15px;
}
.ux-dropdown__dropdown-locator {
  position: absolute;
  top: calc(100% - 1px);
  transform: scaleY(0);
  transform-origin: top;
  transition: transform 250ms ease-in-out;
  width: 100%;
  z-index: 100;
}
.ux-dropdown__menu {
  background-color: var(--ux-input-background-color);
  border: var(--ux-input-border-width) solid var(--ux-button-border-color);
  border-top: 0;
}
.ux-dropdown__menu .ux-list__filter-input {
  border-left: 0;
  border-right: 0;
  margin-bottom: 10px;
  padding-left: 25px;
  padding-right: 25px;
}
.ux-dropdown__menu--radio-items {
  padding-bottom: 10px;
}
.ux-dropdown__list {
  padding: 10px 10px 10px 0;
}
.ux-dropdown__list > li {
  padding: 0 25px;
}
.ux-dropdown.ux-dropdown--down .ux-dropdown__label ux-icon {
  transform: rotate(180deg);
}
.ux-dropdown.ux-dropdown--down .ux-dropdown__dropdown-locator {
  transform: scaleY(1);
}